<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
           <img src="../assets/envionyx-logo.png" alt="" style="height: 35px;">
                 <img class="ms-1" src="../assets/envionyx-banner.png" alt="" style="height: 20px;">
 
        <!-- <div style="font-family: 'Kanit-bold';color: #0374B0FF;" class="h4">เข้าสู่ระบบ</div> -->
         <!-- <div style="color: #0374B0FF;">WATERLEVEL PLATFORM</div> -->
        <p class="mt-2 h4">กรุณากรอกข้อมูลเพื่อเข้าสู่ระบบ</p>
      </div>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username" style="font-family: 'Kanit-bold';">ชื่อผู้ใช้</label>
          <input
            id="username"
            v-model="formData.username"
            type="text"
            placeholder="กรอกชื่อผู้ใช้"
            required
            :disabled="loading"
          />
        </div>

        <div class="form-group">
          <label for="password" style="font-family: 'Kanit-bold';">รหัสผ่าน</label>
          <input
            id="password"
            v-model="formData.password"
            type="password"
            placeholder="กรอกรหัสผ่าน"
            required
            :disabled="loading"
          />
        </div>

        <div v-if="error" class="error-message">
          {{ error }}
        </div>

        <div v-if="success" class="success-message">
          {{ success }}
        </div>

        <button type="submit" class="login-button" :disabled="loading" style="font-family: 'Kanit-bold';">
          <span v-if="!loading">เข้าสู่ระบบ</span>
          <span v-else>กำลังเข้าสู่ระบบ...</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';  // ✅ import useRouter

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter();  // ✅ สร้าง instance ของ router

    const formData = ref({
      username: '',
      password: ''
    });

    const loading = ref(false);
    const error = ref('');
    const success = ref('');

    const handleLogin = async () => {
      error.value = '';
      success.value = '';
      loading.value = true;

      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/signin`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData.value)
        });
        const data = await response.json();
        if (response.ok) {
          success.value = 'เข้าสู่ระบบสำเร็จ!';
          if (data.accessToken) {
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);
            
            localStorage.setItem('role', data.user.role);
            localStorage.setItem('email', data.user.email);
          }
          console.log('Login successful:', data);
          // ✅ ใช้ router.push แทน this.$router.push
          setTimeout(() => {
            router.push('/');
          }, 1000);
        } else {
          error.value = data.message || 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง';
        }
      } catch (err) {
        error.value = 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง';
        console.error('Login error:', err);
      } finally {
        loading.value = false;
      }
    };

    return {
      formData,
      loading,
      error,
      success,
      handleLogin
    };
  }
};
</script>


<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e4e4e421;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  width: 500px;
  height: 500px;
  background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9a7  100%);
  border-radius: 50%;
  top: -250px;
  right: -250px;
  opacity: 0.1;
}

.login-container::after {
  content: '';
  position: absolute;
  width: 400px;
  height: 400px;
  /* background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); */
    background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9a7  100%);
  border-radius: 50%;
  bottom: -200px;
  left: -200px;
  opacity: 0.1;
}

.login-card {
  background: white;
  border-radius: 24px;
  /* box-shadow: 0 10px 40px #0ea4e95c; */
  padding: 50px 40px;
  width: 100%;
  max-width: 440px;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-header h1 {
  background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9a7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 32px;
  margin-bottom: 12px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.login-header p {
  color: #8b8b8b;
  font-size: 15px;
  font-weight: 400;
}

.login-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.form-group input {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #f0f0f0;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  background-color: #fafafa;
}

.form-group input:focus {
  outline: none;
  border-color: #0ea4e9a7;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.08);
  background-color: white;
}

.form-group input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.error-message {
  background-color: #fee;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
  border: 1px solid #fcc;
}

.success-message {
  background-color: #efe;
  color: #3c3;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
  border: 1px solid #cfc;
}

.login-button {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9a7 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px  #0ea4e9a7;
  margin-top: 10px;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px  #0ea4e9a7;
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 10px  #0ea4e9a7;
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 480px) {
  .login-card {
    padding: 30px 20px;
  }

  .login-header h1 {
    font-size: 24px;
  }
}
</style>